<template>
    <div class="card mb-1">
        <header class="card-header p-1" v-toggle="`${$parent._uid}-accordion-${uniqueId}`" @click="closeOtherItems">
            <slot name="header" :item="item" :uniqueId="uniqueId">
                <button type="button" class="btn btn-info btn-block">{{item.header}}</button>
            </slot>
        </header>
        <oc-collapse :id="`${$parent._uid}-accordion-${uniqueId}`" v-model="$parent.activeItems[uniqueId]">
            <div class="card-body">
                <div class="card-text">
                    <slot name="content" :item="item" :uniqueId="uniqueId">
                        {{item.content}}
                    </slot>
                </div>
            </div>
        </oc-collapse>
    </div>
</template>
<script>
import Counter from '@/helpers/Counter'

export default {
    name: 'oc-accordion-item',
    props: {
        startOpened: {
            type: Boolean,
            default: undefined
        },
        item: {
            type: Object,
            default: () => ({})
        }
    },
    data() {
        return {
            safeId: undefined
        }
    },
    created() {
        const uniqueIndexer = new Counter(`accordion-items`)
        this.safeId = uniqueIndexer.increment()

        // determine start opened
        let startOpened

        if( this.item.startOpened !== undefined ) {
            startOpened = this.item.startOpened
        }
        else if( this.startOpened !== undefined ) {
            startOpened = this.startOpened
        }
        else {
            startOpened = this.$parent.startOpened
        }

        Vue.set(this.$parent.activeItems, this.safeId, startOpened)
        //
    },
    computed: {
        uniqueId() {
            return this.safeId
        }
    },
    methods: {
        closeOtherItems()
        {
            if( this.$parent.onlyOneActive === false ) {
                return
            }

            for (let uniqueId in this.$parent.activeItems)
            {
                if( +uniqueId !== +this.uniqueId ) {
                    Vue.set(this.$parent.activeItems, uniqueId, false)
                }
            }
        }
    }
}
</script>
<style scoped>
.card-header {
    cursor: pointer;
}
</style>
